import { defineComponent as _defineComponent } from 'vue'
import {computed } from "vue";
// import ConversionClubLogo from "@/views/pages/main/ConversionClubLogo.vue";
import ConversionClubLogoMasked from "@/views/pages/main/ConversionClubLogoMasked.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionClubBpsBanner',
  props: {
  logoColor: {
    type: String,
    default: '#ffffff'
  },
  year: {
    type: Number || String,
    default: 2023
  }
},
  setup(__props) {

const props = __props;



const logoColor = computed(() => props.logoColor ? props.logoColor : '#ffffff')
const year = computed(() => props.year ? props.year : 2023)

return { __sfc: true,props, logoColor, year, ConversionClubLogoMasked }
}

})